import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-04d11693"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notion-user-dropdown" }
const _hoisted_2 = { class: "notion-user-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Avatar",
  src: "/media/icons/my-icons/user.png",
  class: "notion-user-dropdown-avatar"
}, null, -1))
const _hoisted_4 = { class: "notion-user-name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notion-user-separator" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-right" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sign Out", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Storage.get("userName")), 1)
    ]),
    _hoisted_5,
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
      class: "notion-user-action"
    }, _hoisted_8)
  ]))
}